import { axiosInstance } from '../axiosInstance';

export const logout = async (
  token: string | null,
): Promise<{ message: string }> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await axiosInstance.post(
    `/users/logout`,
    {},
    {
      headers: headers,
    },
  );
  return response.data;
};
